import React from 'react';
import { CSVReader } from 'react-papaparse';
import { getHeavysetData, getUniqueWorkouts, getUniqueExercises, getCSVLineData } from '../../data/helpers';
import { Row, Col, Container } from '../../styles/Grid';
import Card from '../Dashboard/Card';
import { useHistory } from "react-router-dom";

const CSVUpload = ({ getHeavyData, getWorkouts, getExercises }) => {
  let history = useHistory();
  
  const handleOnDrop = (result) => {
    const csvData = getCSVLineData(result);
    const heavysetData = getHeavysetData(csvData);
    const uniqueWorkouts = getUniqueWorkouts(csvData);
    const uniqueExercises = getUniqueExercises(csvData);
    getWorkouts(uniqueWorkouts);
    getExercises(uniqueExercises);
    getHeavyData(heavysetData);
    history.push('/')
  }

  const handleOnError = (err, file, inputElem, reason) => {
    console.log(err);
  };

  const handleOnRemoveFile = (data) => {
    console.log(data);
  };

  const papaParseConfig = {
    header: true,
    transformHeader: (header) => {
      if (header === 'Workout Name') {
        return 'workout';
      }

      if (header === 'Exercise Name') {
        return 'exercise';
      }

      return header.toLowerCase();
    },
    skipEmptyLines: true,
  };

  return (
      <Container>
        <Row>
          <Col size={1}>
            <Card>
              <h3 className="Card__title">Upload HeavySet CSV Data</h3>
              <CSVReader
                onDrop={handleOnDrop}
                onError={handleOnError}
                noClick
                style={{
                  margin: 24,
                  dropArea: {
                    borderColor: '#d8dee9',
                    borderRadius: 4,
                  },
                  dropAreaActive: {
                    borderColor: '#a3be8c',
                  }
                }}
                config={papaParseConfig}
                addRemoveButton
                onRemoveFile={handleOnRemoveFile}
              >
                <span>Drop CSV file here to upload.</span>
              </CSVReader>
            </Card>
          </Col>
        </Row>
      </Container>


  );
}

export default CSVUpload;
